import { Typography, useTheme, useMediaQuery } from '@mui/material';
import { HeaderWrapper, TextWrapper } from './styles';
import { useSearchFilterNotesStore } from '@/stores/searchFilterNotesStore';
import { FC } from 'react';

interface NotesHeaderProps {
  title?: string;
  description?: string;
}

const NotesHeader: FC<NotesHeaderProps> = ({ title, description }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md')); // 900px and below

  const { searchQuery } = useSearchFilterNotesStore();

  return (
    <HeaderWrapper
      sx={{
        flexDirection: isMobile ? 'column' : 'row',
        height: isMobile ? 'auto' : '64px',
        alignItems: isMobile ? 'flex-start' : 'center',
        gap: isMobile ? 2 : 0,
      }}
    >
      <TextWrapper
        sx={{
          justifyContent: searchQuery ? 'center' : 'space-between',
          width: isMobile ? '100%' : 'auto',
        }}
      >
        <Typography variant="h5" fontWeight="700">
          {searchQuery ? (
            <>
              Result for{' '}
              <Typography component="span" sx={{ color: 'GrayText', fontSize: '1.5rem', fontWeight: '700' }}>
                "{searchQuery}"
              </Typography>
            </>
          ) : (
            (title ?? 'My Notes')
          )}
        </Typography>
        {!searchQuery && <Typography variant="body1">{description ?? 'Manage and review your notes.'}</Typography>}
      </TextWrapper>
    </HeaderWrapper>
  );
};

export default NotesHeader;
